import React, { createContext, useContext, useState, useEffect } from 'react';

const StoreContext = createContext();

export const useStore = () => useContext(StoreContext);

export const StoreProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load data from localStorage on mount
    const storedUser = localStorage.getItem('moloji_user');
    const storedDomains = localStorage.getItem('moloji_domains');
    
    if (storedUser) setUser(JSON.parse(storedUser));
    if (storedDomains) setDomains(JSON.parse(storedDomains));
    
    setLoading(false);
  }, []);

  const login = (email, password) => {
    // Mock login - accept any email/password for MVP
    const newUser = { id: 'user_1', email, plan: 'free' };
    setUser(newUser);
    localStorage.setItem('moloji_user', JSON.stringify(newUser));
    return true;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('moloji_user');
  };

  const upgradePlan = () => {
    if (!user) return;
    const updatedUser = { ...user, plan: 'pro' };
    setUser(updatedUser);
    localStorage.setItem('moloji_user', JSON.stringify(updatedUser));
  };

  const addDomain = (domainName) => {
    if (!user) return;
    
    // Check limits
    if (user.plan === 'free' && domains.length >= 1) {
      alert("Free plan limited to 1 domain. Upgrade to Pro!");
      return false;
    }

    const newDomain = {
      id: Math.random().toString(36).substr(2, 9),
      name: domainName,
      price: null,
      views: 0,
      createdAt: new Date().toISOString(),
    };

    const updatedDomains = [newDomain, ...domains];
    setDomains(updatedDomains);
    localStorage.setItem('moloji_domains', JSON.stringify(updatedDomains));
    return true;
  };

  const getDomainByName = (name) => {
    // For demo purposes, we look in local state. 
    // In a real app, this would query a DB.
    // We also return a mock domain if it matches the "demo" pattern for non-users.
    const found = domains.find(d => d.name.toLowerCase() === name.toLowerCase());
    if (found) return found;
    
    // Fallback for demo if not found in local user storage (simulate public view)
    // In a real app, this would fetch from backend. 
    // Here we only show what's in localStorage, which simulates "database".
    return null; 
  };

  return (
    <StoreContext.Provider value={{ 
      user, 
      domains, 
      login, 
      logout, 
      addDomain, 
      upgradePlan,
      getDomainByName,
      loading 
    }}>
      {children}
    </StoreContext.Provider>
  );
};